var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaliveFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 102,
    viewBox: "0 0 160 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3117 87.5732H57.5012V101.135H53.5679V87.5732H47.7891V84.3929H63.3117V87.5732Z",
    fill: "#282727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60402 91.6781L0 83.6306V101.135H3.93332V91.5457L9.60402 96.2974L15.2766 91.5457V101.135H19.2099V83.6306L9.60402 91.6781Z",
    fill: "#282727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7578 84.3929V101.135H103.766V97.9545H94.6576V84.3929H90.7578Z",
    fill: "#282727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.457 84.3929V101.135H109.523V84.3929H113.457Z",
    fill: "#282727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2176 87.5733V84.3931H26.5234V101.135H42.2176V97.9546H30.4568V94.2655H40.4765V91.2624H30.4568V87.5733H42.2176Z",
    fill: "#282727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.997 87.5732V84.3929H144.305V101.135H159.997V97.9545H148.236V94.2654H158.256V91.2623H148.236V87.5732H159.997Z",
    fill: "#282727"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.033 83.6307L65.0469 101.135H69.5618L75.033 91.5272L80.5043 101.135H85.0192L75.033 83.6307Z",
    fill: "#282727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.002 101.897L119.016 84.3929H123.529L129.002 94.0007L134.473 84.3929H138.988L129.002 101.897Z",
    fill: "#282727"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.837 57.4974H101.53L85.9624 30.5345L91.6405 20.6993L110.452 53.2788H122.401L91.6405 0L79.9878 20.1848L68.3333 0L29.1641 67.8452H64.4223L77.5495 45.1065L71.5731 34.7586L58.4459 57.4974H47.0877L68.3333 20.6993L95.5533 67.8452H130.812L124.837 57.4974Z",
    fill: "url(#paint0_linear_13148_55563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13148_55563",
    x1: 79.9878,
    y1: 67.0434,
    x2: 79.9878,
    y2: 0.645959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F1985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3007F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaliveFooter);
export default __webpack_public_path__ + "static/media/metalive-footer.b1cea100bbb0087024c9363b9c5eda06.svg";
export { ForwardRef as ReactComponent };